export const STATUS_COLORS: Record<string, string> = {
    Overdue: 'red',
    Pending: 'orange',
    'In Progress': 'blue',
    Completed: 'green',
    Cancelled: 'gray',
    'Divisional Manager Review': 'yellow',
    'Awaiting Divisional Manager Approval': 'yellow',
    'Price Change Pending': 'yellow',
};

export const ACTIVE_SURVEY_STATUSES = [
    'Pending',
    'In Progress',
    'Overdue',
    'Divisional Manager Review',
] as const;

export const HISTORY_SURVEY_STATUSES = [
    'Completed',
    'Price Change Pending',
    'Cancelled',
] as const;

export const PROGRESS_COLOR_CONFIG = [
    { min: 100, color: 'progressGreen', textColor: 'progressGreen' },
    { min: 60, color: 'progressBlue', textColor: 'progressBlue' },
    { min: 50, color: 'progressOrange', textColor: 'progressOrange' },
    { min: 1, color: 'progressRed', textColor: 'progressRed' },
] as const;

export const PCR_CREATION_REASONS = [
    'Competitive Pricing',
    'Advertising Error',
    'Special Price',
] as const;

export type PcrCreationReason = (typeof PCR_CREATION_REASONS)[number];

export const NA_REASONS = [
    'Price already competitive',
    'Margin too low',
    'Product being discontinued',
    'Supplier price increase pending',
    'Recent price change',
    'Strategic pricing decision',
    'Other',
] as const;

export type NaReason = (typeof NA_REASONS)[number];
